<template>
  <div class="join-us-container">
    <div class="apply-form">
      <div class="apply-form-container">
        <div class="side">
          <div class="member-right-header">
            <p class="header-title">联盟成员权益</p>
          </div>
          <div class="member-right-content" v-for="(item, index) in memberRights" :key="index">
            <img :src="item.title.img"  v-if="item.title.img" class="member-img">
            <p v-else class="member-title">{{item.title.label}}</p>
            <ul>
              <li v-for="(list, index) in item.list" :key="index" class="member-right-item">
                <img :src="require('@/assets/images/join-us-li.png')" class="item-img">
                <p class="item-list">{{list}}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="main">
          <ApplyForm></ApplyForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyForm from '@/components/ApplyForm'
import { memberRights } from '@/utils/helper'
export default {
  data () {
    return {
      memberRights: []
    }
  },
  created () {
    this.memberRights = memberRights;
  },
  components: {
    ApplyForm
  }
}
</script>

<style lang="scss" scoped>
.join-us-container {
  min-height: 690px;
  background-color: #FBFBFB;
  margin: 0 auto;
  position: relative;
  padding: 64px 0;
  .apply-form {
    background-color: #FBFBFB;
    min-height: 690px;
    margin-bottom: 120px;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .apply-form-container {
      min-height: 690px;
      margin: 0 auto;
    }
    .side {
      float: left;
      // background: url(~@/assets/images/apply-sidebar-bg.png) bottom center no-repeat #FFFFFF;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
      width: 368px;
      height: 693px;
      margin-right: 48px;
      text-align: left;
      border: 3px solid #D8B84E;
      border-top: none;
      .member-right-header {
        height: 56px;
        line-height: 56px;
        background: url(~@/assets/images/join-us-header.png) bottom right no-repeat #D8B84E;
        background-size: contain;
        .header-title {
          font-size: 18px;
          color: #fff;
          margin-left: 32px;
        }
      }
      ul {
        border-bottom: 1px solid;
        padding-bottom: 5px;
        border-color: rgba($color: #cccccc, $alpha: 0.5)
      }
      .member-right-content {
        padding: 22px 22px 0 22px;
        // border-bottom: 1px solid #ccc;
      }
      .member-right-content:last-child ul{
        border: none;
      }
      .member-img {
        margin-bottom: 14px;
        display: block;
        max-height: 46px;
       }
      .member-title {
        font-size: 18px;
        color: #0044CC;
        font-weight: 600;
        margin-bottom: 25px;
      }
      .member-right-item {
        display: flex;
        margin-bottom: 10px;
        .item-img {
          height: 15px;
          width: 15px;
          margin-right: 16px;
        }
        .item-list {
          font-size: 12px;
          color: #666;
          line-height: 18px;
        }
      }
    }
    .main {
      float: right;
      width: 784px;
    }
  }
}
</style>
